<template>
    <div class="explanation-head" style="max-height: 50vh;" ref="wrap">
        <div class="clearfix">
            <span class="btn-label">{{ media.media_type_name }}</span>
        </div>
        <h1>{{media.title}}</h1>
        <div class="data-info">
            <p class="asset-data-desc" v-html="media.description"></p>
            <ul class="asset-data-meta">
                <li v-if="media.child_theme_name">{{ media.theme_name }} &gt; {{ media.child_theme_name }}</li>
                <li class="bar">{{media.major_category_name}} &gt; {{media.minor_category_name}}</li>
                <li class="bar" v-if="media.copyright != '한국문화원연합회'">{{media.copyright}}</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        media: { type: Object, required: true },
    },
    mounted(){
        this.checkHeight(50);
    },
    methods: {
        // 주기적으로 반복해서 정보박스 높이 측정
        checkHeight(interval){
            setTimeout(e=>{
                if( this.$refs.wrap.clientHeight > 10 ){
                    this.$emit('explanation-head-height', this.$refs.wrap.clientHeight);
                } else {
                    this.checkHeight(50);
                }
            }, interval);
        }
    }
}
</script>